'use client'

import dynamic from 'next/dynamic'
import { ErrorBoundary } from 'react-error-boundary'

import { EmptyState } from '@/components/EmptyState'

import { MapLocationProps } from './types'

const MapLocationLazy = dynamic(
  () => import('./MapLocation').then((mod) => mod.MapLocation),
  {
    ssr: false,
  }
)

function FallbackError() {
  return (
    <EmptyState
      title="Oops, gagal memuat peta"
      description="Terjadi kesalahan pada sistem saat memuat peta"
      size="sm"
    />
  )
}

export function MapWithBoundary({
  position,
  name,
  className = '',
  minHeight = 300,
}: MapLocationProps) {
  return (
    <ErrorBoundary FallbackComponent={FallbackError}>
      <MapLocationLazy
        position={position}
        name={name}
        className={className}
        minHeight={minHeight}
      />
    </ErrorBoundary>
  )
}
